import { graphql, compose } from 'react-apollo'
import get from 'lodash/get'
import BirthdayBlessing from './components/index'
import { patientQueryById } from './actions/queries'
import { receiveBirthdayPresent } from './actions/mutation'

export default compose(graphql(patientQueryById, {
  name: 'birthday',
  options: props => ({
    variables: {
      patientId: get(props, 'match.params.patientId'),
    },
    fetchPolicy: 'network-only'
  })
}),
  graphql(receiveBirthdayPresent, { name: 'receiveBirthdayPresent' }),
)(BirthdayBlessing)



// WEBPACK FOOTER //
// ./src/modules/birthday/index.js